import { Widget } from '@ally/data-types-customization'

export enum LoadingState {
  UNLOADED = 'UNLOADED',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}

export enum DashboardView {
  DEFAULT = 'DEFAULT',
  TILE = 'TILE',
}

export interface KeyValPair {
  [key: string]: string
}

export interface ComponentLookupObj {
  [key: string]: React.ReactElement
}

export interface CustomizeApiAlertProps {
  shouldRender: boolean
  type: string
  isDashboardError: boolean
}

export interface ViewsObj {
  name: string
  value: string
}

export interface OrderObj {
  name: string
  order: number
}

export interface AccountTypesObj extends OrderObj {
  lob: string
}

// TODO update type to this
// export type CustomizeDataObj = Omit<
//   CustomizationOptions,
//   'customizationId' | 'customerId'
// >
export interface CustomizeDataObj {
  accountTypes: AccountTypesObj[]
  channel: string
  lobs: OrderObj[]
  views: ViewsObj[]
  widgets: Widget[]
}

export type DataTypeName = 'accountTypes' | 'lobs' | 'widgets'

export type DataType<T> = T extends 'accountTypes'
  ? AccountTypesObj
  : T extends 'lobs'
  ? OrderObj
  : T extends 'widgets'
  ? OrderObj
  : never

export interface WidgetObj {
  copy: {
    displayName: string
    description: string
  }
  isEligible: () => boolean
}

export type WidgetKey =
  | 'accountsOverviewWidget'
  | 'stkWidget'
  | 'transfersWidget'
  | 'weeklyFinancialInsightsWidget'
  | 'badgeWidget'

export type WidgetConfigObj = Partial<Record<WidgetKey, WidgetObj>>
